import {
  privateInstance,
  nohandlerPrivateInstanceWithRetry,
  mapUrl
} from "../configs";
import moment from "moment";
import { mappers } from "@/mappers";

export const inventoryApi = {
  async getInventoryRecords(params) {
    let url = "/inventory/api/record/";

    if (params) {
      url += "?";
      const paramsArray = [];
      if (params.latest) paramsArray.push(`latest=true`);
      if (params.date)
        paramsArray.push(
          `date=${moment(params.date).format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ")}`
        );
      if (params.store) paramsArray.push(`store=${params.store}`);
      if (params.product) paramsArray.push(`product=${params.product}`);
      url += paramsArray.join("&");
    }

    const res = await privateInstance.get(mapUrl(url));
    return res.data.map(x => mappers.mapInventoryRecord(x));
  },
  async searchInventoryRecords(params) {
    let url = "/inventory/api/record/search/";

    if (params) {
      url += "?";
      const paramsArray = [];
      if (params.take) paramsArray.push(`take=${params.take}`);
      if (params.product) paramsArray.push(`product=${params.product}`);
      if (params.start) paramsArray.push(`start=${params.start}`);
      if (params.end) paramsArray.push(`end=${params.end}`);
      if (params.group !== undefined) paramsArray.push(`group=${params.group}`);
      url += paramsArray.join("&");
    }

    const res = await privateInstance.get(url);
    return res.data.map(x => mappers.mapInventoryRecord(x));
  },
  async getComputedInventory(params) {
    let url = "/inventory/api/record/computedsearch/";

    if (params) {
      url += "?";
      const paramsArray = [];
      if (params.product) paramsArray.push(`product=${params.product}`);
      if (params.start) paramsArray.push(`start=${params.start}`);
      if (params.end) paramsArray.push(`end=${params.end}`);
      if (params.corrected !== undefined)
        paramsArray.push(`corrected=${params.corrected}`);
      url += paramsArray.join("&");
    }

    const res = await privateInstance.get(url);
    return res.data.map(x => mappers.mapInventoryRecord(x));
  },
  async postInventoryRecord(record) {
    let url = "/inventory/api/record/";
    const res = await nohandlerPrivateInstanceWithRetry.post(url, record);
    return mappers.mapInventoryRecord(res.data);
  },
  async postInventoryRecordNormalHandler(record) {
    let url = "/inventory/api/record/";
    const res = await privateInstance.post(url, record);
    return mappers.mapInventoryRecord(res.data);
  },
  async patchInventoryRecord(record) {
    let url = `/inventory/api/record/${record.id}/`;
    const res = await privateInstance.patch(url, record);
    return mappers.mapInventoryRecord(res.data);
  },
  async getInventoryTransactions(params) {
    let url = "/inventory/api/transaction/";

    if (params) {
      url += "?";
      const paramsArray = [];
      if (params.take) paramsArray.push(`take=${params.take}`);
      if (params.waste !== undefined) paramsArray.push(`waste=${params.waste}`);
      if (params.product) paramsArray.push(`product=${params.product}`);
      if (params.start)
        paramsArray.push(
          `start=${moment(params.start).format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ")}`
        );
      if (params.end)
        paramsArray.push(
          `end=${moment(params.end).format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ")}`
        );
      if (params.group !== undefined) paramsArray.push(`group=${params.group}`);
      url += paramsArray.join("&");
    }
    const res = await privateInstance.get(url);
    return res.data;
  },
  async postInventoryTransaction(transaction) {
    let url = "/inventory/api/transaction/";
    const res = await privateInstance.post(url, transaction);
    return res.data;
  },
  async retrieveInventoryTransaction(transactionId) {
    let url = `/inventory/api/transaction/${transactionId}/`;
    const res = await privateInstance.get(url);
    return res.data;
  },
  async patchInventoryTransaction(transaction) {
    let url = `/inventory/api/transaction/${transaction.id}/`;
    const res = await privateInstance.patch(url, transaction);
    return res.data;
  },
  async getInventoryRecordsCorrections(params) {
    let url = "/inventory/api/record-correction/";
    if (params) {
      url += "?";
      const paramsArray = [];
      if (params.take) paramsArray.push(`take=${params.take}`);
      if (params.product) paramsArray.push(`product=${params.product}`);
      if (params.start) paramsArray.push(`start=${params.start}`);
      if (params.end) paramsArray.push(`end=${params.end}`);
      if (params.omitted !== undefined)
        paramsArray.push(`omitted=${params.omitted}`);
      if (params.grouped !== undefined) paramsArray.push(`grouped=true`);
      url += paramsArray.join("&");
    }
    const res = await privateInstance.get(url);
    return res.data;
  },
  async patchInventoryRecordsCorrections(id, correction) {
    const res = await privateInstance.patch(
      `/inventory/api/record-correction/${id}/`,
      correction
    );
    return res.data;
  },
  async getInventoryCorrectionValues(params) {
    let url = "/inventory/api/inventory-correction-value/";
    if (params) {
      url += "?";
      const paramsArray = [];
      if (params.product) paramsArray.push(`product=${params.product}`);
      if (params.recent) paramsArray.push(`recent=${params.recent}`);
      url += paramsArray.join("&");
    }
    const res = await privateInstance.get(url);
    return res.data;
  },
  async getInventoryAlerts() {
    const res = await privateInstance.get(`/inventory/api/inventory-alert/`);
    return res.data;
  },
  async postInventoryAlert(data) {
    const res = await privateInstance.post(
      `/inventory/api/inventory-alert/`,
      data
    );
    return res.data;
  },
  async retrieveInventoryAlert(id) {
    const res = await privateInstance.get(
      `/inventory/api/inventory-alert/${id}/`
    );
    return res.data;
  },
  async patchInventoryAlert(id, data) {
    const res = await privateInstance.patch(
      `/inventory/api/inventory-alert/${id}/`,
      data
    );
    return res.data;
  },
  async deleteInventoryAlert(id) {
    const res = await privateInstance.delete(
      `/inventory/api/inventory-alert/${id}/`
    );
    return res.data;
  }
};
